import innerBanner from "../assets/images/inner-banner.png";
import { NavLink } from "react-router-dom";

function About() {

  return (
    <>
      {/* Inner Banner */}
      <section id="inner-banner-wrapper">
        <div className="banner-image">
          <img className="w-100" src={innerBanner} alt="About Banner" />
        </div>
        <div className="breadcrumb">
          <h2>About</h2>
          <ul>
            <li>
              <NavLink to="/">Home &gt; </NavLink>
            </li>
            <li>About</li>
          </ul>
        </div>
      </section>

      {/* About Section */}
      <div id="cart-wrapper">
        <div className="container">

         <div className="about-container">
            <h3>Actu-All Chemicals: A Journey of Growth and Innovation</h3>
            <p>
              Founded in 2011, Actu-All Chemicals began as a one-man operation in
              a single room within a larger facility in Oss, Netherlands,
              specializing in the trade of solvents and laboratory chemicals for
              the Dutch market.
            </p>
            <p>
              The company’s growth accelerated in 2018 with the addition of
              experienced sales and technical professionals. That same year,
              Actu-All established a modest production facility for water
              chemistry in Hoogeveen, marking its transition from a trading
              company to a manufacturer.
            </p>
            <p>
              A major milestone came in 2021 when Actu-All acquired the chemical
              division of LPS BV, a laboratory chemicals dealer. This acquisition
              not only strengthened its market position but also allowed Actu-All
              to expand its operations within the very facility where it was
              founded.
            </p>
            <p>
              In 2022, Actu-All Chemicals became part of{" "}
              <strong>bioKEMIX Worldwide,</strong> an international chemical
              enterprise. This strategic acquisition provided access to an
              extensive network of production facilities and global partnerships,
              enabling Actu-All to enhance its supply chain and operational
              capabilities. To further improve customer service and logistics, the
              company established third-party-operated warehouses in Amsterdam,
              Wilp, and Son-en-Breugel.
            </p>
            <p>
              By 2023, Actu-All had expanded its production capabilities, taking
              over the entire Hoogeveen facility. This expansion allowed the
              company to manufacture a comprehensive range of{" "}
              <strong>
                ready-to-use solutions, analytical standard solutions,
                custom-produced formulations, and solvent mixtures,
              </strong>{" "}
              further solidifying its position as a key player in the chemical
              industry.
            </p>
            <p>
              The momentum continued in 2024, as Actu-All strengthened its sales
              force by recruiting professionals with multinational corporate
              experience, propelling it to become one of the fastest-growing
              chemical businesses in the Netherlands.
            </p>
            <p>
              In 2025, Actu-All extended its footprint into Germany by
              establishing a warehouse to serve the local market. Additionally,
              the company assumed management of its group subsidiaries engaged in
              the production of high-purity products for liquid chromatography in
              Meckenheim and Wesel, reinforcing its presence in the European
              chemical sector.
            </p>
            <h3>Actu-All Today: A Leading Chemical Supplier</h3>
            <p>
              From its humble beginnings in 2011, Actu-All Chemicals has grown
              into a recognized leader in the production and distribution of
              chemicals. Today, the company operates:
            </p>
            <ul>
              <li>
                <strong>Three company-owned warehouses:</strong> Oss (NL),
                Hoogeveen (NL), Wesel (DE)
              </li>
              <li>
                <strong>Three third-party warehouses:</strong> Amsterdam (NL),
                Wilp (NL), Son-en-Breugel (NL)
              </li>
              <li>
                <strong>Two production sites:</strong> Hoogeveen (NL) & Wesel (DE)
              </li>
              <li>
                <strong>
                  Over 10,000 SKUs in stock, including 5,000 in-house manufactured
                  products
                </strong>
              </li>
            </ul>
            <p>
              Despite its rapid expansion, Actu-All remains true to its core
              philosophy: <br />
              <strong>
                "The customer is the most important part of our business, and we
                are committed to serving their needs before our own."
              </strong>
            </p>
          </div>

        </div>
      </div>
    </>
  );
}

export default About;
